import { type FC, type PropsWithChildren } from 'react';
import type { Folder } from 'store/automationsPage/automations.redux';
import { useDragAndDropContext } from './context';
import { StyledDropZone } from './styles';
import type { FolderStruct } from '@kizen/kds/FoldersTree';

export const FolderDropZone: FC<
  PropsWithChildren<{ folderStructure: FolderStruct<Folder> }>
> = ({ children, folderStructure }) => {
  const {
    dragging,
    dropFolder,
    dragItem,
    onHoverInDropZone,
    onHoverOutDropZone,
    isAllowed,
  } = useDragAndDropContext();

  const handleMouseEnter = () => {
    onHoverInDropZone(folderStructure);
  };

  const handleMouseLeave = () => {
    onHoverOutDropZone();
  };

  const isActive =
    dragging && dropFolder?.id === folderStructure.data.id && isAllowed;
  const isSelf = dragging && dragItem?.id === folderStructure.id;

  return (
    <>
      {dragging ? null : children}
      <StyledDropZone
        className="folder-drop-zone"
        dragging={dragging}
        isActive={isActive}
        isAllowed={isAllowed}
        isSelf={isSelf}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </>
  );
};
